import { render } from "./newListModal.vue?vue&type=template&id=6d2beaf5&ts=true"
import script from "./newListModal.vue?vue&type=script&lang=ts"
export * from "./newListModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__